import { RedirectIfSignedIn, SignInForm } from '@/features/auth'

function SignIn() {
  return (
    <div className="w-screen h-screen mesh-bg-primary p-4 overflow-y-auto">
      <div className="flex flex-col justify-center min-h-full">
        <div className="flex flex-col bg-white rounded max-w-[600px] w-full p-6 gap-2.5 mx-auto">
          <RedirectIfSignedIn />
          <SignInForm />
        </div>
      </div>
    </div>
  )
}

export default SignIn
